import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderFulfillmentAddPage } from 'src/app/modals/order-fulfillment-add/order-fulfillment-add.page';

const routes: Routes = [
  {
    path: '',
    component: OrderFulfillmentAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderFulfillmentAddPage]
})
export class OrderFulfillmentAddPageModule {}
